/**
 * Tag helpers, kept out of `TagsInput.tsx` so that file exports only a
 * component (the react-refresh boundary rule).
 */

/**
 * Splits the stored comma-joined tag string into trimmed, non-empty tags.
 *
 * This is the one place the wire format is decoded, so the form input and the
 * submit payload cannot disagree about what "two tags" means.
 */
export function parseTags(value: string): string[] {
  return value
    .split(",")
    .map((tag) => tag.trim())
    .filter(Boolean);
}
